import {FlexAlign, FlexJustify, StackHorizontal, useTranslation} from "@twigsby/frontend-framework";
import React from "react";

const Renew = () => {
    const { t } = useTranslation();

    return (
        <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
            <h2 className={'mb-0'}>{t('settings.renew.title')}</h2>
        </StackHorizontal>
    )
}

export { Renew }
